import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { Text } from '@daedalus/atlas/Text';
import { getPrioritizedMeals, MEAL_AMENITIES, MealAmenity } from '@daedalus/core/src/offer/business/meal';
import { Offer } from '@daedalus/core/src/offer/types/offer';
import { RoomOffer } from '@findhotel/sapi';
const roomLabels = defineMessages({
  payLater: {
    id: 'paymentSchedule.payLater',
    defaultMessage: 'Pay later'
  },
  allInclusive: {
    id: 'mealType.meals',
    defaultMessage: 'Breakfast included, Lunch included, Dinner included'
  },
  breakfast: {
    id: 'mealType.breakfastIncluded',
    defaultMessage: 'Breakfast included'
  },
  lunch: {
    id: 'mealType.lunchIncluded',
    defaultMessage: 'Lunch included'
  },
  dinner: {
    id: 'mealType.dinnerIncluded',
    defaultMessage: 'Dinner included'
  },
  fullBoard: {
    id: 'meals.fullBoard',
    defaultMessage: 'Breakfast, lunch and dinner included'
  },
  halfBoard: {
    id: 'meals.halfBoard',
    defaultMessage: 'Breakfast and dinner included'
  },
  meals: {
    id: 'mealType.meals',
    defaultMessage: 'Breakfast included, Lunch included, Dinner included'
  }
});
type RoomLabelsKeys = keyof typeof roomLabels;
interface Props {
  offer: RoomOffer;
}
const LabelsContainer = /*#__PURE__*/styled('div')({
  name: "LabelsContainer",
  class: "le3tth4",
  propsAsIs: false
});
const getMealsAmenitiesFromRoomOffer = (offer: Pick<Offer, 'services'>): MealAmenity[] => {
  return (offer?.services?.filter(service => MEAL_AMENITIES.has(service)) ?? []) as MealAmenity[];
};
export const RoomLabels = ({
  offer
}: Props) => {
  const {
    formatMessage
  } = useIntl();
  if (!offer) return null;
  const {
    canPayLater
  } = offer;
  const meals = getMealsAmenitiesFromRoomOffer(offer);
  const roomLabelItems = {
    payLater: canPayLater
  };
  type RoomLabelItemsKeys = keyof typeof roomLabelItems;
  const translatedRoomLabels = Object.keys(roomLabelItems).reduce((out: string[], key) => {
    if (roomLabelItems[key as RoomLabelItemsKeys] && roomLabels[key as RoomLabelsKeys]) {
      return out.concat(formatMessage(roomLabels[key as RoomLabelsKeys]));
    }
    return out;
  }, []);
  const translatedMealsLabels = getPrioritizedMeals(meals).map(meal => meal && roomLabels[meal as RoomLabelsKeys] && formatMessage(roomLabels[meal as RoomLabelsKeys]));
  const translatedLabels = ([] as string[]).concat(translatedRoomLabels, translatedMealsLabels);
  if (translatedLabels.length <= 0) return null;
  return <LabelsContainer>
      {translatedLabels.map(label => <Text variant="bodyS" key={label}>
          {label}
        </Text>)}
    </LabelsContainer>;
};

require("./RoomLabels.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomLabels.tsx");